/**
 * Wer eine Warnung über ein Fahrzeug zu sehen bekommt.
 *
 * ## Führung und Schlusswagen
 *
 * Die Führung entscheidet, ob gewartet oder eine Navigation angestoßen wird.
 * Der Schlusswagen fährt hinten und ist der Einzige, der ein zurückgefallenes
 * oder liegengebliebenes Fahrzeug ohne Umkehr erreicht. Beide müssen es wissen
 * (A-18). Alle übrigen nicht: Bei zehn Fahrzeugen bekäme jeder jede fremde
 * Warnung, und nach der dritten sieht niemand mehr hin.
 *
 * ## Niemals über sich selbst
 *
 * Wer zurückfällt, hat seinen Rückstand ohnehin groß vor Augen — er ist die
 * Hauptzahl seiner Anzeige. Eine zusätzliche Warnung darüber sagt ihm nichts
 * Neues, verdeckt die Karte und will weggetippt werden. Am Steuer ist das ein
 * Griff zu viel für nichts.
 *
 * Aufgefallen ist es beim Schlusswagen: Er sieht die Warnungen aller anderen —
 * und bekam deshalb auch die über sich selbst. Über andere muss er sie
 * weiterhin bekommen; das ist der Sinn der Rolle.
 */
export function receivesWarning(role, aboutSelf) {
    if (aboutSelf) {
        return false;
    }
    return role === 'leader' || role === 'sweeper';
}
//# sourceMappingURL=warnings.js.map